<template>
    <div id="expertContainer">
        <div id="outsideWrapper"> 
            <div id="expertTitle"><span class="lineBox"></span>三博专家<span class="lineBox"></span></div>
            <el-carousel :interval="5000" arrow="always" height="320px">
                <el-carousel-item>
                    <div class="expertWrapper">
                        <div class="expertImg expert">
                            <img src="../../assets/imgs/home/exp1.png">
                            <p>赵洪宾 / 总顾问</p>
                        </div>
                        <div class="expertText expert">
                            哈尔滨工业大学 教授 博士生导师，中国供水排水协会科学技术委员会顾问，国务院特殊津贴专家，是我国给水管网系统著名专家。在我国率先开展管网系统分析、优化运行及建模理论等的研究，使给水管网研究达到了国际先进水平，促进了我国给水管网学科的发展。主持了国家自然科学基金、“十一·五”“十二·五”水专项、英国皇家学会基金和英国文化教育委员会基金等项目。研究成果在天津、济南、哈尔滨、沈阳、大连、沧州等国内多个城市推广应用，获得了多个省、部级科技进步奖。培养了博士生三十余人，硕士生百余人。出版专著《给水管网理论与计算》、《给水管网系统理论与分析》、《给水管道卫生学》，译著《给水工程的事故与防治措施》、《降低供水漏损》。
                        </div>
                    </div>
                </el-carousel-item>
                <el-carousel-item>
                    <div class="expertWrapper">
                        <div class="expertImg expert">
                            <img src="../../assets/imgs/home/exp2.jpg">
                            <p>刘遂庆 / 顾问</p>
                        </div>
                        <div class="expertText expert">
                            同济大学 教授，博士生导师，曾任同济大学环境科学与工程学院院长、城市污染控制国家（南方）工程研究中心副主任，是我国给水管网系统著名专家。学术专长为给水排水工程、水资源和水环境工程系统最优化理论、水力模拟及水力计算。主持了多项国家自然科学基金、国家科技攻关及国际合作研究项目，先后赴10余个国家讲学和学术交流，并多次主持或联合主持国际和全国学术会议。
                        </div>
                    </div>
                </el-carousel-item>
                <el-carousel-item>
                    <div class="expertWrapper">
                        <div class="expertImg expert">
                            <img src="../../assets/imgs/home/exp4.jpg">
                            <p>周玉文 / 顾问</p>
                        </div>
                        <div class="expertText expert">
                            教授 教授，博士生导师，哈尔滨工业大学工学博士，是我国排水管网系统著名专家。曾任北京工业大学建工学院副院长，市政工程学科部责任教授、学科部主任和北京市重点实验室常务副主任，《给水排水》杂志编委。出版理论专著、教材和翻译科技著作10余部，获省、部级科技进步奖9项，获国家专利和软件著作权20余项。国家首届国内最有影响100篇学术论文获得者。
                        </div>
                    </div>
                </el-carousel-item>
                <el-carousel-item>
                    <div class="expertWrapper">
                        <div class="expertImg expert">
                            <img src="../../assets/imgs/home/exp3.jpg">
                            <p>卜义惠 / 顾问</p>
                        </div>
                        <div class="expertText expert">
                            教授级高工，哈尔滨工业大学工学博士，曾任中国市政工程东北设计研究总院院长，是集给排水水务与科学管理于一身的专家、规划师。长期致力于水系统的规划、设计和建设，曾参编《给水排水工程快速设计手册》，发表学术论文多篇。兼任全国给水深度处理学会理事，吉林大学兼职教授，长春科技大学兼职教授。曾荣获建设部有突出贡献的中青年专家、长春市劳动模范称号。
                        </div>
                    </div>
                </el-carousel-item>
            </el-carousel>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Screen3',
}
</script>

<style scoped>
    #expertContainer{
        background:#eef4ff;
    }
    #outsideWrapper{
        width: 1120px;
        margin: 0 auto;
        padding-bottom: 90px;
        overflow: hidden;
    }
    #expertTitle{
        display: flex;                      /*定位（写在父元素中）*/
        justify-content:center;           /*水平居中*/
        align-items:Center;             /*垂直居中 */
        height: 170px;
        font-size: 30px;
    }
    .lineBox{
        display: inline-block;
        width: 85px;
        height: 2px;
        background: #2e3138;
        margin: 0 60px;
    }
    .expertWrapper{
        width: 985px;
        margin: 0 auto;
    }
    .expert{ 
        padding: 5px 8px;
        border-radius: 20px;
        box-shadow: 0px 0px 5px 3px #dbe7ff;
        height: calc(100% - 10px);
        background: #fff;
        height: 310px;
    }
    .expertImg{
        width: 224px;
        float: left;
        
    }
    .expertImg>img{
        width: 224px;
        height: 235px;
    }
    .expertImg p{
        font-size: 24px;
        text-align: center;
        margin-top: 25px;
        font-family: 'expert'; 
        font-weight: bold;
    }
    .expertText{
        width: 670px;
        float: right;
        font-family: 'expert';
        line-height: 35px;
        height: 240px;
        font-weight: 500;
        padding: 30px 25px 50px 25px;
        letter-spacing: 3px;
    }
</style>
